import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { JwtService } from '../services/jwt.service';
import { environment } from 'src/environments/environment';

import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  private uri = environment.url;

  constructor(private _jwtService: JwtService, private _router: Router, private _toastr: ToastrService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if ((request.params.has('username') && request.params.has('password')) || request.url === `${this.uri}/authenticate` ||
      request.url === `${this.uri}/user/resetPassword` || request.url === `${this.uri}/user/forgotPassword` || request.params.has('token')) {
      return next.handle(request);
    }

    if (this._jwtService.isTokenExpired) {
      this._router.navigate(['/signin']);
      this._toastr.error('Session expired', 'Signed Out');
      return next.handle(request);
    }

    request = request.clone({
      setHeaders: {
        Authorization: 'Bearer ' + this._jwtService.base64Token,
        Accept: 'application/json'
      }
    });

    return next.handle(request);
  }
}
